<select [formControl]="optionControl">
  <option [value]="'no-value'">&nbsp;</option>
  <option *ngFor="let option of options | async" [value]="option.value">
    {{ option.label }}
  </option>
</select>
